// src/store/slices/auth/authUserSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthUserState {
  roles: string[];
  isLoading: boolean;
  hasLoaded: boolean;
  error: string | null;
}

const initialState: AuthUserState = {
  roles: [],
  isLoading: false,
  hasLoaded: false,
  error: null,
};

const authUserSlice = createSlice({
  name: 'authUser',
  initialState,
  reducers: {
    setRoles(state, action: PayloadAction<string[]>) {
      state.roles = action.payload;
      state.hasLoaded = true;
    },
    setIsLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
      if (action.payload) state.hasLoaded = true;
    },
    clearRoles(state) {
      state.roles = [];
      state.hasLoaded = false;
      state.error = null;
    },
  },
});

export const { setRoles, setIsLoading, setError, clearRoles } =
  authUserSlice.actions;

export default authUserSlice.reducer;
